import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'remind-refund-order-record', // 资源路径
  }
})
